import React from 'react';
import { Shield, Clock, Headphones, Lock, CheckCircle2, Award, CreditCard, RefreshCw } from 'lucide-react';

const trustFeatures = [
  {
    icon: Shield,
    title: "100% Secure Checkout",
    description: "Bank-level SSL encryption protects your payment information"
  },
  {
    icon: RefreshCw,
    title: "Risk-Free Guarantee",
    description: "Application fee is fully refundable if you don't qualify"
  },
  {
    icon: Clock,
    title: "24-Hour Activation",
    description: "Your platform is activated within 24 hours of approval"
  },
  {
    icon: Headphones,
    title: "Dedicated Support",
    description: "Personal account manager + AI support team available 24/7"
  }
];

const TrustBanner = () => {
  return (
    <section className="py-12 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 border-y border-slate-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {trustFeatures.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className="text-center">
                <div className="w-12 h-12 bg-emerald-500/10 rounded-xl flex items-center justify-center mx-auto mb-3">
                  <Icon className="w-6 h-6 text-emerald-400" />
                </div>
                <h3 className="text-white font-semibold text-sm mb-1">{feature.title}</h3>
                <p className="text-slate-400 text-xs">{feature.description}</p>
              </div>
            );
          })}
        </div>
        
        {/* Security Badges */}
        <div className="flex flex-wrap items-center justify-center gap-6 mt-8 pt-8 border-t border-slate-700">
          <div className="flex items-center gap-2 text-slate-400 text-sm">
            <Lock className="w-4 h-4 text-green-400" />
            <span>SSL Secured</span>
          </div>
          <div className="flex items-center gap-2 text-slate-400 text-sm">
            <CreditCard className="w-4 h-4 text-blue-400" />
            <span>Stripe Verified</span>
          </div>
          <div className="flex items-center gap-2 text-slate-400 text-sm">
            <Award className="w-4 h-4 text-emerald-400" />
            <span>BBB Accredited</span>
          </div>
          <div className="flex items-center gap-2 text-slate-400 text-sm">
            <CheckCircle2 className="w-4 h-4 text-cyan-400" />
            <span>Verified Business</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBanner;
